// Datas do painel (`spec/17-frontend.md` §4.6): tudo formatado em `America/Sao_Paulo`
// via `Intl`, nunca com os getters locais do `Date` (o navegador do usuário pode estar
// em outro fuso e a virada do dia mudaria de lugar).

export const TIME_ZONE = 'America/Sao_Paulo';
export const LOCALE = 'pt-BR';

type DateInput = Date | string | number;

function toDate(value: DateInput): Date {
  return value instanceof Date ? value : new Date(value);
}

const dateFormat = new Intl.DateTimeFormat(LOCALE, {
  timeZone: TIME_ZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const dateTimeFormat = new Intl.DateTimeFormat(LOCALE, {
  timeZone: TIME_ZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const timeFormat = new Intl.DateTimeFormat(LOCALE, {
  timeZone: TIME_ZONE,
  hour: '2-digit',
  minute: '2-digit',
});

const shortFormat = new Intl.DateTimeFormat(LOCALE, {
  timeZone: TIME_ZONE,
  day: '2-digit',
  month: '2-digit',
});

/** `11/09/2026` */
export function formatDate(value: DateInput): string {
  return dateFormat.format(toDate(value));
}

/** `11/09/2026 21:30` */
export function formatDateTime(value: DateInput): string {
  return dateTimeFormat.format(toDate(value)).replace(', ', ' ');
}

/** `21:30` */
export function formatTime(value: DateInput): string {
  return timeFormat.format(toDate(value));
}

/** `11/09`, eixo de gráfico e listas densas. */
export function formatShortDate(value: DateInput): string {
  return shortFormat.format(toDate(value));
}

/**
 * `YYYY-MM-DD` **no fuso de São Paulo**. É o que os filtros de período mandam para a
 * API (`spec/13` §4.1): a API interpreta a data no fuso, então mandar
 * `toISOString().slice(0, 10)` jogaria a virada do dia três horas para frente.
 */
export function toIsoDate(value: DateInput): string {
  const parts = dateFormat.formatToParts(toDate(value));
  const get = (type: Intl.DateTimeFormatPartTypes): string =>
    parts.find((part) => part.type === type)?.value ?? '';
  return `${get('year')}-${get('month')}-${get('day')}`;
}

/** Hoje em `America/Sao_Paulo`, como `YYYY-MM-DD`. */
export function todayIsoDate(now: DateInput = new Date()): string {
  return toIsoDate(now);
}

/** `YYYY-MM-DD` deslocado em dias, sem passar por fuso nenhum. */
export function addDaysToIsoDate(isoDate: string, days: number): string {
  const shifted = new Date(`${isoDate}T12:00:00Z`);
  shifted.setUTCDate(shifted.getUTCDate() + days);
  return shifted.toISOString().slice(0, 10);
}
